export default class Esito{
    Codice;
    Descrizione;

    constructor(){}
}